var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{scopedSlots:_vm._u([{key:"default",fn:function({ validate, invalid }){return [_c('form',{staticClass:"find-property-manually",on:{"submit":function($event){$event.preventDefault();validate().then(() => _vm.onSubmit(invalid))}}},[_c('BaseLabel',{class:_vm.hideDetails ? 'mt-10' : 'mt-3',style:({ 'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%' }),attrs:{"text":"Postcode","actionBtnLabel":"Use address finder"},on:{"click:actionBtn":function($event){return _vm.$emit('useAddressFinder')}}}),_c('BaseInput',{staticClass:"mt-2",style:({
        'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
      }),attrs:{"name":"postcode","dataUiid":_vm.dataUiid ? `${_vm.dataUiid}PostCode_search` : '',"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"hide-details":_vm.hideDetails,"rules":{
        required: {
          required: true,
          fieldLabel: 'Postcode',
        },
        regex: {
          required: true,
          pattern:
            '^(?![Ii][Mm])(?![Jj][Ee])(?![Gg][Yy])[A-Za-z]{1,2}[0-9A-Za-z]{1,2} ?[0-9][A-Za-z]{2}$',
          customMessage: 'Please enter a valid postcode.',
        },
        is_duplicate_address_field: {
          street: '@street',
          district: '@district',
          town: '@town',
          county: '@county',
        },
      },"aria-label":"Postcode"},model:{value:(_vm.address.PostCode.Value),callback:function ($$v) {_vm.$set(_vm.address.PostCode, "Value", $$v)},expression:"address.PostCode.Value"}}),_c('BaseLabel',{class:_vm.hideDetails ? 'mt-9' : 'mt-3',attrs:{"text":"Property house number and street name"}}),_c('BaseInput',{staticClass:"mt-2",style:({
        'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
      }),attrs:{"name":"street","dataUiid":_vm.dataUiid ? `${_vm.dataUiid}Street` : '',"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"hide-details":_vm.hideDetails,"rules":{
        required: {
          required: true,
          fieldLabel: 'Property house number and street name',
        },
        regex: {
          required: true,
          pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
          customMessage:
            'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
        },
        maxLength: {
          fieldLabel: 'Property house number and street name',
          length: _vm.maxLengthStreet,
        },
        is_duplicate_address_field: {
          postcode: '@postcode',
          district: '@district',
          town: '@town',
          county: '@county',
        },
      },"aria-label":"Street"},model:{value:(_vm.address.Street.Value),callback:function ($$v) {_vm.$set(_vm.address.Street, "Value", $$v)},expression:"address.Street.Value"}}),_c('BaseLabel',{class:_vm.hideDetails ? 'mt-9' : 'mt-3',attrs:{"text":"District"}}),_c('BaseInput',{staticClass:"mt-2",style:({
        'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
      }),attrs:{"name":"district","dataUiid":_vm.dataUiid ? `${_vm.dataUiid}District` : '',"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"hide-details":_vm.hideDetails,"rules":{
        regex: {
          required: true,
          pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
          customMessage:
            'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
        },
        maxLength: {
          fieldLabel: 'District',
          length: 30,
        },
        is_duplicate_address_field: {
          postcode: '@postcode',
          street: '@street',
          town: '@town',
          county: '@county',
        },
      },"aria-label":"District"},model:{value:(_vm.address.District.Value),callback:function ($$v) {_vm.$set(_vm.address.District, "Value", $$v)},expression:"address.District.Value"}}),_c('BaseLabel',{class:_vm.hideDetails ? 'mt-9' : 'mt-3',attrs:{"text":"Town"}}),_c('BaseInput',{staticClass:"mt-2",style:({
        'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
      }),attrs:{"name":"town","dataUiid":_vm.dataUiid ? `${_vm.dataUiid}Town` : '',"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"hide-details":_vm.hideDetails,"rules":{
        required: {
          required: true,
          fieldLabel: 'Town',
        },
        regex: {
          required: true,
          pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
          customMessage:
            'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
        },
        maxLength: {
          fieldLabel: 'Town',
          length: 30,
        },
        is_duplicate_address_field: {
          postcode: '@postcode',
          street: '@street',
          district: '@district',
          county: '@county',
        },
      },"aria-label":"Town"},model:{value:(_vm.address.Town.Value),callback:function ($$v) {_vm.$set(_vm.address.Town, "Value", $$v)},expression:"address.Town.Value"}}),_c('BaseLabel',{class:_vm.hideDetails ? 'mt-9' : 'mt-3',attrs:{"text":"County"}}),_c('BaseInput',{staticClass:"mt-2",style:({
        'max-width': _vm.$vuetify.breakpoint.lgAndUp ? '480px' : '100%',
      }),attrs:{"name":"county","dataUiid":_vm.dataUiid ? `${_vm.dataUiid}County` : '',"height":_vm.$vuetify.breakpoint.lgAndUp ? '48' : '60',"min-width":_vm.$vuetify.breakpoint.lgAndUp ? '110' : '',"hide-details":_vm.hideDetails,"rules":{
        regex: {
          required: true,
          pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
          customMessage:
            'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
        },
        maxLength: {
          fieldLabel: 'County',
          length: 30,
        },
        is_duplicate_address_field: {
          postcode: '@postcode',
          street: '@street',
          district: '@district',
          town: '@town',
        },
      },"aria-label":"County"},model:{value:(_vm.address.County.Value),callback:function ($$v) {_vm.$set(_vm.address.County, "Value", $$v)},expression:"address.County.Value"}}),_c('BaseButton',{staticClass:"font-weight-bold font-20 pa-7 px-13 mb-10",class:{ 'mt-5': _vm.hideDetails },attrs:{"depressed":"","name":"save","text":"SAVE ADDRESS","rounded":"","block":_vm.$vuetify.breakpoint.lgAndUp ? false : true,"dense":"","color":"psdarkgreen","text-color":"white--text","type":"submit","height":"60","min-width":_vm.$vuetify.breakpoint.lgAndUp ? '324' : '100%',"aria-label":"Save address"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }